import { Star } from "lucide-react";

export function Stars({ value = 0, size = 14 }) {
  const full = Math.round(value);
  return (
    <span className="inline-flex items-center gap-0.5">
      {[1,2,3,4,5].map((i) => (
        <Star key={i} size={size} className={i <= full ? "fill-[#F59E0B] text-[#F59E0B]" : "text-slate-600"} />
      ))}
    </span>
  );
}
